import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';

@Component({
  selector: 'app-print-options',
  templateUrl: './print-options.component.html',
  styleUrls: ['./print-options.component.scss'],
  standalone: false,
})
export class PrintOptionsComponent implements OnInit {
  public message: string = '';
  constructor(
    private navParams: NavParams,
    private modalCtrl: ModalController
  ) {
    this.message = this.navParams.get('message');
  }

  ngOnInit() {}
  selectOption(res: string) {
    this.modalCtrl.dismiss(res);
  }

  async onClose() {
    this.modalCtrl.dismiss();
  }
}
